import _ from 'underscore';
import 'backbone';
import KeywordPlannerView from '@bingads-webui-campaign-legacy/crud-adgroup/view/keywordPlanner';
import LandingPageView from '@bingads-webui-campaign-legacy/crud-adgroup/view/landingPage';

export function decorate(view) {
  return view.extend({
    initialize(options = {}) {
      this.options = options;
      _.bind(view.prototype.initialize, this, options)();
      this.keywordPlannerView = new KeywordPlannerView({
        scenario: 'campaign creation',
        isCampaignCreation: true,
        usePanel: options && options.usePanel,
        activityLogger: options && options.activityLogger,
      });
      this.keywordPlannerTimeout = 500;
      this.keywordPlannerView.on({
        'addAdgroup': (data) => {
          this.addSuggestion(data);
        },
      });

      this.landingPageView = new LandingPageView({
        activityLogger: options && options.activityLogger,
        isForVNext: options && options.isForVNext,
      });
      this.landingPageView.on({
        'urlEntered': (url) => {
          this.keywordPlannerView.onSearch({url});
          this.options.context.set({'LandingPageUrl': url});
        },
      });
    },

    willShow(shouldNotCreateDefaultEditor, shouldNotRenderWhenThereIsNoAdGroup) {
      _.bind(view.prototype.willShow, this)(shouldNotCreateDefaultEditor, shouldNotRenderWhenThereIsNoAdGroup);

      if (_.isObject(this.campaign)) {
        this.checkKeywordPlannerSupport();
      }

      const showLandingPage = this.ko_model.isKeywordPlannerEnabled() && !this.keywordPlannerView.viewmodel.allLocationsUnsupported();

      this.updateLandingPageStatus(showLandingPage);
    },

    render(shouldNotCreateDefaultEditor = false) {
      _.bind(view.prototype.render, this)();
      if (!_.isUndefined(this.campaign)) {
        this.ko_model.adGroups.subscribe((valueArray) => {
          this.keywordPlannerView.updateAdgroupsList(_.map(valueArray, (value) => {
            return {
              'id': value.ko_model.Id(),//eslint-disable-line
              'name': value.ko_model.Name,
              'index': value.ko_model.options.index,
            };
          }));
        });
        this.landingPageView.render();
        this.$('.landing-page-container').append(this.landingPageView.el);

        if (!shouldNotCreateDefaultEditor) {
          this.create();
        }

        this.keywordPlannerView.render();
        this.$('.keyword-planner-container').append(this.keywordPlannerView.el);
      }
      return this;
    },

    updateLandingPageStatus(show) {
      this.ko_model.showLandingPage(show);
    },

    checkKeywordPlannerSupport() {
      const isLanguagesSupported = KeywordPlannerView.isLanguageSupported(this.campaign.Languages);

      this.ko_model.isKeywordPlannerEnabled(isLanguagesSupported);
      this.keywordPlannerView.setLanguages(this.campaign.Languages);

      if (this.ko_model.isKeywordPlannerEnabled()) {
        this.keywordPlannerView.setLocationTargetingByCampaign();
      }
    },

    create() {
      _.bind(view.prototype.create, this)();

      const updateView = _.last(this.ko_model.adGroups());

      updateView.on({
        'delete': () => {
          setTimeout(this.moveKeywordPlanner.bind(this), this.keywordPlannerTimeout);
        },
        'seedKeywordsEntered': (seedKeywords) => {
          if (_.isArray(seedKeywords) && seedKeywords.length > 0) {
            this.keywordPlannerView.onSearch({
              keywords: seedKeywords,
            });
          }
        },
        'selectThisAdGroup': (adGroup) => {
          if (_.isNull(this.selectedAdGroup) || this.selectedAdGroup.options.index !== adGroup.options.index) {
            this.moveKeywordPlanner();
          }
        },
      });
    },

    moveKeywordPlanner() {
      const keywordPlannerTop = _.isNull(this.selectedAdGroup) ? 0 : this.selectedAdGroup.$el.position().top;

      this.ko_model.keywordPlannerTopValue(keywordPlannerTop);
    },

    changeSelectedAdGroup(newSelected) {
      _.bind(view.prototype.changeSelectedAdGroup, this, newSelected)();
      setTimeout(this.moveKeywordPlanner.bind(this), this.keywordPlannerTimeout);
    },

    addSuggestion(data) {
      const name = this.ko_model.getUniqueName(data.data.Name);
      const keywords = _.pluck(data.data.Suggestions, 'Keyword');

      switch (data.mode) {
      case 'AddToAllAdGroups': {
        const targets = this.ko_model.adGroups();

        _.each(targets, (target) => {
          target.addSuggestion(keywords, undefined, undefined, data.sourceReqId);
        });
        this.save(true);
        break;
      }

      case 'AddToSelectedAdGroups': {
        if (_.isArray(data.selectedAdgroups) && data.selectedAdgroups.length > 0) {
          const targets = _.pluck(data.selectedAdgroups, 'index');

          _.each(this.ko_model.adGroups(), (adGroup) => {
            if (_.contains(targets, adGroup.ko_model.options.index)) {
              adGroup.addSuggestion(keywords, undefined, undefined, data.sourceReqId);
            }
          });
          this.save(true);
        }
        break;
      }

      default: {
        const suggestedAvgCpc = _.result(data.data && data.data.AggregateMetric, 'AverageCPC');

        if (_.isObject(this.selectedAdGroup) && this.selectedAdGroup.subView.isEmpty()) {
          this.selectedAdGroup.addSuggestion(keywords, name, suggestedAvgCpc, data.sourceReqId);
          return;
        }
        this.create();
        this.selectedAdGroup.addSuggestion(keywords, name, suggestedAvgCpc, data.sourceReqId);

        break;
      }
      }
    },
  });
}
